var map = {
	"./gallery_00.jpg": 2055,
	"./gallery_01.jpg": 2056,
	"./gallery_02.jpg": 2057,
	"./gallery_03.jpg": 2058,
	"./gallery_04.jpg": 2059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2054;